import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Lib/old/old'; // old
import 'Bem/site/menu-left/menu-left';
import 'Bem/site/search-content/search-content';

svgSpriteLoader('/site/default/svg/sprite.svg?v=20190605');